<template lang="jade">
  .container-fluid
    .row
      .mapping_main.col-md-12.clearfix(v-else)
        header.mapping_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12.hidden-xs mapping
          h1.title.col-md-10.col-sm-10.col-xs-12.visible-xs(v-on:click="isSingleMapping = !isSingleMapping") mapping
            span.pull-right.fa(v-bind:class="isSingleMapping ? 'fa-list' : 'fa-th-large'")
        section.mapping_content_list.clearfix.col_space--xs(v-show="isSingleMapping" v-bind:class="{'list_mode':isSingleMapping}")
          header.output_header.clearfix
            h2.output_title_bar.title_bar.clearfix.col-md-8.col-xs-2 Output
            .profile_function_group.col-md-4.col-md-offset-0.col-xs-8.col-xs-offset-2.clearfix
              .function__single.load.col-xs-6
                dropdown
                  button(slot='button').btn.btn-primary.base_white
                    | load
                    i.fa.fa-angle-down
                  ul.dropdown-menu(slot='dropdown-menu')
                    li(v-for="($index,profile) in profiles")
                      a(v-on:click='loadProfileFrom($index)') {{profile.label}}
              .function__single.save.col-xs-6
                dropdown
                  button(slot='button').btn.btn-primary.base_white
                    | save as
                    i.fa.fa-angle-up
                  ul.dropdown-menu(slot='dropdown-menu')
                    li(v-for='($index,profile) in profiles')
                      a(v-on:click='saveCurProfileTo($index)') {{profile.label}}
          section.list_group.row_space--xs.clearfix
            .col-lg-6.col-md-6.col-sm-3.col-xs-6.form-horizontal(
              v-for="(output, input) in mapping"
              v-bind:class="{'clear-left': output == 0}"
              v-show="output !== 'all' ")
              .form-group
                label.input_name.control-label {{ output }}. {{ outputCards[output].name }}
                select.form-control(v-model="input" v-on:change="updateList(output, input)")
                  option(v-for="( v_out , v_in  ) in mapping" v-bind:value="v_out") {{inputCards[v_out].name}} ({{v_out}})
                  option(value='0')
                    i.fa.fa-times
                    |Mute
                //- span.caret
            //- .input__single.col-xs-12
            //-   label
            //-   input
            //- button(v-on:click="updateList").btn.btn-success.col-xs-12 Apply
        section.mapping_content.clearfix.col_space--xs(v-else)
          header.output_header.clearfix
            h2.output_title_bar.title_bar.clearfix.col-md-8.col-xs-2 Output
            .profile_function_group.col-md-4.col-md-offset-0.col-xs-8.col-xs-offset-2.clearfix
              .function__single.load.col-xs-6
                dropdown
                  button(slot='button' data-toggle='dropdown').btn.btn-primary.base_white
                    | load
                    i.fa.fa-angle-down
                  ul.dropdown-menu(slot='dropdown-menu')
                    li(v-for="($index,profile) in profiles")
                      a(v-on:click='loadProfileFrom($index)') {{profile.label}}
              .function__single.save.col-xs-6
                dropdown
                  button(slot='button' data-toggle='dropdown').btn.btn-primary.base_white
                    | save as
                    i.fa.fa-angle-up
                  ul.dropdown-menu(slot='dropdown-menu')
                    li(v-for='($index,profile) in profiles')
                      a(v-on:click='saveCurProfileTo($index)') {{profile.label}}
          //- ========================= START OF THE CARDS SECTION
          //- ========================= Outputs Cards
          //- // p OUT {{ outputCards | json }}
          //- // p mapping {{ mapping | json }}
          //- //p IN {{ inputCards | json }}
          section.output_card_group.card_group.clearfix
            .card__group__inner.clearfix.hidden-xs
              card.col-xs-12.output__card__single.slide__single.clearfix(
                v-for="(outIndex, card) in outputCards"
                v-ref:desktop-output-card
                card-type="output"
                @detail="handleCardDetail"
                @focus="desktopOutputFocus"
                v-bind:is-favorite="favoritePort == outIndex"
                v-bind:output-data.sync="card"
                v-bind:input-data="inputCards[mapping[outIndex]]"
                v-on:drop.prevent="handleDrop($event,outIndex)"
                v-on:dragover.prevent="handleOver($event)"
                v-bind:class="{outAll:outIndex === '0'}"
                v-on:dragstart="handleDragStart($event, outIndex, false)"
                v-bind:is-installer="user.installer"
                v-bind:output-focus="desktop.outputFocus"
                v-bind:highlight-input-id="desktop.inputFocus == mapping[outIndex] && card.name != 'all'")
            //- ======================= SWIPER
            .card__group__inner.clearfix.hidden-sm.hidden-md.hidden-lg
              swiper.no_arrow(
                direction="horizontal"
                v-bind:initial-page="mobile.outputFocus"
                @slide-change-end="onOutSwiperEnd")
                card.col-xs-12.output__card__single.slide__single.clearfix(
                  v-for="(outIndex, card) in outputCards"
                  card-type="output"
                  v-bind:is-favorite="favoritePort == outIndex"
                  @detail="handleCardDetail"
                  v-bind:output-data.sync="card"
                  v-bind:input-data="inputCards[mapping[outIndex]]"
                  v-bind:class="{outAll:outIndex === '0'}"
                  v-bind:is-installer.sync="user.installer"
                  )
          //- ===================== map to btn
          section.map_function.clearfix.row_space--xs.visible-xs
            .mapTo.col-sm-7.col-xs-12.col-centered
              button.btn.btn-success(v-on:click="mobileUpdateMapping")
                i.fa.fa-arrow-up
                |&nbsp;To
          header.input_header.clearfix
            h2.input_title_bar.title_bar.card_group.clearfix Input
          //- ===================== inputs
          section.input_card_group.card_group.clearfix
            .card__group__inner.clearfix.hidden-lg.hidden-md.hidden-sm
              swiper.no_arrow(
                direction="horizontal"
                v-bind:initial-page="mobile.inputFocus"
                @slide-change-end="onInSwiperEnd"
                v-bind:transitioning.sync="inputTrans"
                )
                card.col-xs-12.input__card__single(
                  v-for="(inIndex,card) in inputCards"
                  card-type="input"
                  @detail="handleCardDetail( null, card, false, $event)"
                  v-bind:class="{outMute:card.name === 'mute', 'mobile-highlight': inIndex == mapping[mobile.outputFocus]}"
                  v-bind:input-data.sync="card"
                  v-bind:input-id='inIndex'
                  v-bind:is-installer.sync="user.installer"
                  v-bind:input-focus="inIndex"
                  )
            .card__group__inner.clearfix.hidden-xs
              .slide_group.clearfix
                card.col-xs-12.input__card__single(
                  v-for="(inIndex,card) in inputCards"
                  card-type="input"
                  v-ref:desktop-input-card
                  @focus="desktopInputFocus"
                  @detail="handleCardDetail"
                  v-bind:class="{outMute:card.name === 'mute'}"
                  v-bind:id="card.name"
                  v-bind:input-data.sync="card"
                  draggable
                  v-on:dragstart="handleDragStart($event, inIndex, true)"
                  v-bind:is-installer.sync="user.installer"
                  v-bind:input-focus="desktop.inputFocus"
                  v-bind:highlight-input-id="mapping[desktop.outputFocus] == card._id"
                  )
    card-modal(
      v-bind:show.sync="showCardDetail"
      v-bind:input-data="editing.inData"
      v-bind:output-data="editing.outData"
      v-bind:hdcp-capability="hdcp"
      v-bind:favorite-port="favoritePort"
      v-bind:is-installer.sync="user.installer"
      v-bind:is-out="editing.isOut"
      )
    modal(
      title="Confirm"
      v-bind:show.sync= "showConfirm"
      effect= "zoom"
      v-bind:callback='confirmCb'
      ok-text="Yes"
      cancel-text="Cancel")
      .modal-body(slot='modal-body').clearfix {{ confirmMsg }}
</template>

<script>
import $ from 'jquery'
import Card from './Card.vue'
import CardModal from './CardModal.vue'
import { radioGroup, radioBtn, select, modal, dropdown } from 'vue-strap'
import Swiper from 'src/components/Swiper.vue'
import { call, getDeviceFavorite, getUser, photos } from 'src/Service'
import _ from 'lodash'

const SWITCHER = 'SW-5004RZ'

export default {
  components: {
    Card,
    modal,
    radioGroup,
    CardModal,
    Swiper,
    dropdown,
    radio: radioBtn,
    vSelect: select
  },
  data: () => {
    return {
      inputTrans: false,   // for debug only, no use
      user: {},
      showCardDetail: false,
      showConfirm: false,
      confirmMsg: '',
      confirmCb: function () {},
      loggedEvent: '',
      capability: null,
      mapping: {},
      editing: {},
      outputCards: [],
      outputImgs: photos.outputs,
      inputCards: [],
      inputImgs: photos.inputs,
      profiles: [],
      favoritePort: null,
      mobile: {
        outputFocus: null,  // for swiper
        inputFocus: null  // for swiper
      },
      desktop: {
        outputFocus: null,
        inputFocus: null
      },
      isSingleMapping: false,
      deviceModel: ''
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    let inputCards = {}
    let outputCards = {}
    let profiles = []
    return call(mac, 'dxGetPortInfo').then(({inputs, outputs}) => {
      inputCards = inputs
      outputCards = outputs
      for (let key in inputCards) { // check data type and give it default value
        if (!(inputCards[key].photo && _.isString(inputCards[key].photo))) {
          if (inputCards[key].photo) {
            console.log(inputCards[key].photo)
            inputCards[key].photo = inputCards[key].photo.toString
          } else {
            inputCards[key].photo = '1'
          }
        }
        if (!inputCards[key].name) { // set default if empty
          inputCards[key].name = 'No Name'
        }
      }
      return call(mac, 'dxGetAbout')
    })
    .then(({capability, model}) => {
      this.capability = capability
      this.deviceModel = model
      return call(mac, 'dxGetMatrixStatus')
    })
    .then(({mapping, channels, links, quality}) => {
      this.mapping = mapping
      for (let port in inputCards) {
        _.assignIn(inputCards[port], {
          _id: port,
          cardType: 'input',
          img: this.inputImgs[port],
          quality: quality.inputs[port],
          link: links.inputs[port]
        })
      }
      for (let port in outputCards) {
        _.assignIn(outputCards[port], {
          _id: port,
          cardType: 'output',
          img: this.outputImgs[port],
          quality: quality.inputs[port],
          link: links.outputs[port]
        })
      }
      return call(mac, 'dxGetHDCP')
    })
    .then(({inputs, outputs}) => {
      for (let port in inputCards) {
        _.assignIn(inputCards[port], {
          HDCP: inputs[port]
        })
      }
      for (let port in outputCards) {
        _.assignIn(outputCards[port], {
          HDCP: outputs[port]
        })
      }
      inputCards[0] = {
        _id: 0,
        name: 'mute'
      }
      outputCards[0] = {
        _id: 0,
        name: 'all'
      }
      return call(mac, 'dxGetMaps')
    })
    .then(({maps}) => {
      for (let key in maps) {
        profiles[key] = {
          label: '',
          value: '',
          mapping: {}
        }
        profiles[key].label = maps[key].name
        profiles[key].value = key
        profiles[key].mapping = maps[key].mapping
      }
      // ======== initial the input & output slider
      return {inputCards, outputCards, profiles}
    })
    .catch(err => {
      this.alert('danger', 'Error', err.message)
    })
  },
  computed: {
    isSwitcher () {
      return this.deviceModel.toUpperCase() === SWITCHER
    },
    hdcp () {
      return {
        inputs: {
          enabled: {
            readable: this.capability.hdcp.inputs.enable.indexOf('r') >= 0,
            settable: this.capability.hdcp.inputs.enable.indexOf('w') >= 0
          },
          engine: {
            readable: this.capability.hdcp.inputs.type.indexOf('r') >= 0,
            settable: this.capability.hdcp.inputs.type.indexOf('w') >= 0
          }
        },
        outputs: {
          enabled: {
            readable: this.capability.hdcp.outputs.enable.indexOf('r') >= 0,
            settable: this.capability.hdcp.outputs.enable.indexOf('w') >= 0
          },
          engine: {
            readable: this.capability.hdcp.outputs.type.indexOf('r') >= 0,
            settable: this.capability.hdcp.outputs.type.indexOf('w') >= 0
          }
        }
      }
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      switch (type) {
        case 'mapping':
          _.assignIn(this.mapping, event)
          break

        case 'info':
          for (let inputNum in event.inputs) {
            let newInputCards = _.cloneDeep(this.inputCards)
            _.assignIn(newInputCards[inputNum], event.inputs[inputNum])
            this.inputCards = newInputCards
          }
          // ========== for output port info update
          for (let outputNum in event.outputs) {
            let newOutputCards = _.cloneDeep(this.outputCards)
            _.assignIn(newOutputCards[outputNum], event.outputs[outputNum])
            this.outputCards = newOutputCards
          }
          break

        case 'links':
          // console.log(event)
          // let key = Object.keys(event.inputs)[0]

          // let Card.vue handle the update
          if (event.inputs && typeof event.inputs === 'object') {
            let newInputCards = _.cloneDeep(this.inputCards)
            let inputKeys = Object.keys(event.inputs)
            for (let key of inputKeys) {
              newInputCards[key].link = event.inputs[key]
            }
            this.inputCards = _.cloneDeep(newInputCards)
          }
          if (event.outputs && typeof event.outputs === 'object') {
            let outputKeys = Object.keys(event.outputs)
            for (let key of outputKeys) {
              console.log(key)
              this.outputCards[key].link = event.outputs[key]
            }
          }
          this.$broadcast('update', mac, {type, event, msg})
          break
        case 'quality':
          if (event.inputs && typeof event.inputs === 'object') {
            let inputKeys = Object.keys(event.inputs)
            for (let key of inputKeys) {
              this.inputCards[key].quality = event.inputs[key]
            }
          }

          if (event.outputs && typeof event.outputs === 'object') {
            let outputKeys = Object.keys(event.outputs)
            for (let key of outputKeys) {
              this.outputCards[key].quality = event.outputs[key]
            }
          }
          // this.alert('success', type, msg)
          break
      }
    },
    user (uid, user) {
      this.user = user
    },
    favoritePort (favoriteData) {
      for (let mac in favoriteData) {
        if (mac === this.$route.params.mac) {
          this.favoritePort = favoriteData[mac]
        }
      }
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    handleCardDetail (outData, inData, isOut) {
      this.editing = {
        outData,
        inData,
        isOut
      }
      if (outData) { // outputs
        if (outData.cardType) {
          this.showCardDetail = true
        }
      } else { // inputs
        if (inData.cardType) {
          this.showCardDetail = true
        }
      }
    },
    // ============== funcitons in drag and drop
    handleDragStart (evt, inIndex, isInput) {
      if (isInput) {
        if (this.desktop.inputFocus !== null && this.desktop.outputFocus === null) {
          this.desktop.inputFocus = Number(inIndex)
        }
        evt.dataTransfer.setData('inIndex', inIndex)
      } else {
        return
      }
    },
    handleDrop (evt, outIndex) {
      if (outIndex === '0') {
        this.handleDropAll(evt)
      } else {
        let inIndex = evt.dataTransfer.getData('inIndex')
        if (inIndex) {
          this.mapping[outIndex] = inIndex
          this.updateMapping('Mapping Changed', {
            [outIndex]: inIndex
          })  // update data to device
        }
      }
      if (!this.desktop.inputFocus && (this.desktop.outputFocus || this.desktop.outputFocus === 0)) {
        this.desktop.outputFocus = Number(outIndex)
      }
      // close judging all or single if
    },
    handleOver () {},
    handleDropAll (evt) {
      let inIndex = evt.dataTransfer.getData('inIndex')
      if (inIndex) {
        for (let key in this.mapping) {
          if (key !== '0') {
            this.mapping[key] = inIndex
          }
        }
        this.updateMapping('Mapping Changed', this.mapping)  // update data to device
      }
    },
    handleConfirmModal (msg, callback) {
      let confirmCb = () => {
        callback()
        this.showConfirm = false
      }
      this.confirmMsg = msg
      this.confirmCb = confirmCb
      this.showConfirm = true
    },
    updateMapping (msg, mappingDiff) {
      call(this.$route.params.mac, 'dxSetMapping', { mapping: mappingDiff }).then(() => {
        // this.alert('success', '', msg)
      }, (err) => {
        this.alert('danger', '', err)
      })
    },
    updateList (output, input) {
      this.updateMapping('Mapping list updated', {
        [output]: input
      })
    },
    // =============== functions in .profile_function_group
    loadProfileFrom (index) {
      call(this.$route.params.mac, 'dxGetMaps').then(({maps}) => {
        this.handleConfirmModal(`Load Profile ${index} and set it to current mapping ?`, () => {
          this.mapping = maps[index].mapping
          this.updateMapping('New Profile loaded', this.mapping)
        })
      })
    },
    saveCurProfileTo (index) {
      this.handleConfirmModal(`Save Current mapping into profiles ${index} ?`, () => {
        call(this.$route.params.mac, 'dxSetMaps', {
          maps: {
            [index]: {
              name: this.profiles[index].label,
              mapping: this.mapping
            }
          }
        })
        .then(({maps}) => {
          this.alert('success', '', 'Current profile saved!')
          console.log('done')
        })
      })
    },
    mobileUpdateMapping () {
      console.log('outFocus', this.mobile.outputFocus)
      console.log('inFocus', this.mobile.inputFocus)
      if (this.mobile.outputFocus === 0) { // focus the 'all' card
        this.mobileUpdateMappingAll()
      } else {
        this.mapping[this.mobile.outputFocus] = String(this.mobile.inputFocus) // convert key to sring
        this.$log('mapping')
        this.updateMapping('Mapping Changed', {
          [this.mobile.outputFocus]: String(this.mobile.inputFocus)
        })  // update data to device
      }
    },
    mobileUpdateMappingAll () {
      for (let key in this.mapping) {
        if (key !== '0') {
          this.mapping[key] = String(this.mobile.inputFocus) // convert key to sring
        }
      }
      this.updateMapping('Mapping Changed all', this.mapping)  // update data to device
    },
    onOutSwiperEnd (currentPage) {
      this.mobile.outputFocus = currentPage
    },
    onInSwiperEnd (currentPage) {
      this.mobile.inputFocus = currentPage
    },
    desktopOutputFocus (clickedOutput) {
      console.log(clickedOutput, this.desktop.inputFocus)
      if (this.desktop.inputFocus !== null) {
        this.applyMapping(this.desktop.inputFocus, Number(clickedOutput))
      } else {
        this.desktop.outputFocus = this.desktop.outputFocus === Number(clickedOutput) ? null : Number(clickedOutput)
      }
    },
    desktopInputFocus (clickedInput) {
      if (this.desktop.outputFocus !== null) {
        this.applyMapping(Number(clickedInput), this.desktop.outputFocus)
      } else {
        this.desktop.inputFocus = this.desktop.inputFocus === Number(clickedInput) ? null : Number(clickedInput)
      }
    },
    applyMapping (input, output) {
      let ie = this.$refs.desktopInputCard[input].$els.content
      let oe = this.$refs.desktopOutputCard[output].$els.content
      let dx = $(oe).offset().left - $(ie).offset().left
      let dy = $(oe).offset().top - $(ie).offset().top
      let outputValueToSet = output
      let inputValueToSet = String(input)
      // keep the value , prevent overwrite by other callbacks
      console.log('set', outputValueToSet, inputValueToSet)
      ie.move(dx, dy, () => {
        if (outputValueToSet === 0) {
          for (let key in this.mapping) {
            if (key !== 0) {
              this.mapping[key] = inputValueToSet
            }
          }
        } else {
          this.mapping[outputValueToSet] = inputValueToSet
        }
        if (outputValueToSet === 0) {
          this.updateMapping('Mapping Changed', this.mapping)
        } else {
          this.updateMapping('Mapping Changed', {
            [outputValueToSet]: inputValueToSet
          })
        }
      })
    }
  }, // close method {}
  ready () {
    this.user = getUser()
    getDeviceFavorite(this.$route.params.mac)
    .then(favoritePort => {
      this.favoritePort = favoritePort
      this.mobile.outputFocus = Number(favoritePort) // initial key = favorite - 1
      this.mobile.inputFocus = 1
    })
  },
  route: {
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';

  /* drag and drop styles */
  [draggable] {
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    /* Required to make elements draggable in old WebKit */
    -khtml-user-drag: element;
    -webkit-user-drag: element;
  }
  li {
    color: black;
  }
  .dragging {
    opacity: 0.8;
    color: #6894D1;
  }
  .drag-over {
    text-decoration: underline;
  }
  .drag-enter {
    color: #C93742;
  }
  /* drag and drop styles */

  /* ==== sections ======*/
  .input_card_group,.output_card_group{
    position: relative;
    @include breakpoint(xxs){
      margin-top: -40px;
    }
  }
  .output_card_group{
    border-bottom:1px solid $GLOBAL_border;
    @include breakpoint(xxs) {
      border-bottom:none;
    }
    .card__group__inner{
      height: 220px;
      margin-top: 30px;
      margin-bottom: -55px;
      @include breakpoint(xxs) {
        margin-bottom: -30px;
      }
    }
    .slide_group{
      margin-top: 50px;
    }
  }
  .input_card_group{
    .card__group__inner{
      @include breakpoint(xxs){
        margin-top: 0px;
      }
    }
  }
  .output_title_bar,.input_title_bar{
    margin-top: 5px;
  }
  .output_title_bar{
    margin-bottom: 0;
    padding: 0;
    padding-left: 15px;
    @include breakpoint(xxs) {
      padding: 0;
    }

  }
  .input_title_bar{
    @include breakpoint(xxs) {
      margin-top: 5px;
      margin-bottom: -10px;
      padding:0;
    }
  }
  /* =========== exception card types ==============*/
  .card.outAll{
    position: absolute;
    width:12.5%;
    left: 150px;
    top: -40px;
    margin-bottom: 0;
    @include breakpoint(sm) {
      width: 25%;
      position: relative;
      top: 0;
      left: 0;
    }
  }
  .card.outMute{
    position: absolute;
    width:100%;
    @include breakpoint(lg) {
      width: 12.5%;
      top: 160px;
    }
    @include breakpoint(md) {
      width: 25%;
      top: 320px;
    }
    @include breakpoint(sm) {
      position: relative;
      width: 25%;
    }
  }

  /* user profile function  */
  .profile_function_group{
    padding:5px 0px ;
    @include breakpoint(xxs) {
      margin-top: -65px;
      margin-left: 90px;
    }
    & .function__single{
      width:70px;
      float: right;
      margin-left: 15px;
      margin-right: 30px;
      @include breakpoint(xxs) {
        margin-left: 0px;
        margin-right: 10px;
      }
      & .btn-group{
        & .btn{
          text-transform:capitalize;
          border-radius: 4px;
          @include breakpoint(xxs){
            font-size: 12px;
            padding:3px 6px;
          }
        }
        & .btn .fa {
          margin-left: 5px;
        }
      }
    }
    & .dropdown-menu{
      left: auto;
      right: 0;
    }
    & .save .dropdown-menu{
      left: auto;
      right: 0;
    }
    & .dropdown-toggle{
      border:none;
      background-color:#ddd;
    }
  }
  .mapTo{
    /* padding:10px 0px; */
    text-align:center;
    font-size: 24px;
    position: relative;
    overflow:visible;
    @include breakpoint(xxs) {
      height: 1px;
      background-color:$pri_dark;
      margin-top: 45px;
    }

    .btn{
      width: 50%;
      @include breakpoint(xxs){
        padding:10px 10px 22px;
        line-height:0;
        position: absolute;
        top: -16px;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
      }
      @include breakpoint(sm){
        padding:10px 0px;
        font-size: 20px;
      }
    }
  }
  .list_group{
    font-size: 14px;
    .form-group{
      position: relative;
      padding-right:15px;
      .form-control{
        padding:3px 6px;
      }
      .caret{
        position: absolute;
        top: 35px;
        right: 10px;
      }
    }
  }
  /* ================== list mode styles ==============*/
  .list_mode{
    .output_header{
      margin-top: 10px;
    }
    .profile_function_group{
      margin-top: -70px;
    }
  }
  /* ================== responsive =================== */
  /* ================== ipad ========================= */
  @include breakpoint(sm) {
    .swiper{
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }
  }
  /* ================== mobile ======================= */
  @include breakpoint(xxs) {
    .output_card_group,.input_card_group{
      margin-top: 0;
      .card__group__inner{
        margin-top: 15px;
        position: relative;
        width: 100%;
        height: 150px;
        overflow:hidden;
      }
      .outAll,.outMute{
        position: relative;
        display:inline-block;
        width: 100%;
        height: 100%;
        padding-left:10px;
        padding-right: 10px;
        float: left;
        margin-bottom: $space_sm;
        left: 0;
        top: 0;
      }
    }
    .output_header{
      margin-bottom: -10px;
    }
  }
  /* =================== iphone5 ========================== */
  @include breakpoint(iFive){
    .output_card_group,.input_card_group{
      height: 120px;
      .outMute{
        margin-bottom: 0;
      }
    }
    .output_header{
      margin-top: -5px;
    }
    .profile_function_group{
      margin-top: -60px;
    }
    .input_title_bar{
      margin-top: -15px;
    }
    .mapTo{
      margin-top: 40px;
      margin-bottom: 5px;
    }
  }
  .mapping_content{
    padding-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// Mapping.vue?85921592